import { apiClient } from '@/lib/api';

// HR-02 — custom field shapes mirror the backend type.
export type CustomFieldType = 'text' | 'number' | 'date';

export interface CustomFieldDef {
  key: string;
  label: string;
  type: CustomFieldType;
  required: boolean;
}

export type HierarchyNodeKey = 'site' | 'level' | 'zone' | 'tunnel' | 'team';

export type HierarchyCustomFields = Partial<Record<HierarchyNodeKey, CustomFieldDef[]>>;

export interface HierarchyLabels {
  id?: string;
  siteLabel: string;
  siteLabelPlural: string | null;
  zoneLabel: string;
  zoneLabelPlural: string | null;
  levelLabel: string;
  levelLabelPlural: string | null;
  tunnelLabel: string;
  tunnelLabelPlural: string | null;
  teamLabel: string;
  teamLabelPlural: string | null;
  // HR-03 — only `tunnel` and `team` are disableable today.
  disabledLevels: ('tunnel' | 'team')[];
  // HR-02 — tenant-defined custom field definitions per hierarchy node type.
  customFields: HierarchyCustomFields;
}

export const hierarchyLabelsService = {
  async getLabels(): Promise<HierarchyLabels> {
    const { data } = await apiClient.get<HierarchyLabels>('/tenant-config/hierarchy-labels');
    return data;
  },

  async updateLabels(labels: Partial<HierarchyLabels>): Promise<HierarchyLabels> {
    const { data } = await apiClient.put<HierarchyLabels>('/tenant-config/hierarchy-labels', labels);
    return data;
  },
};
